class TimeZone {
  public static getTimezone = () => {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  };

  public static getEncodedTimeZone = () => {
    return encodeURIComponent(TimeZone.getTimezone());
  };
}

export default TimeZone;
